<template>
  <div class="animated fadeIn mb-5" v-if="!loading">
    <basic-heading v-if="schedule">
      <span class="float-left mr-2">Edit Schedule - {{ schedule.name() }}</span>
      <template #right-content>
        <header-button-group
          :button_config="button_config"
        ></header-button-group>
      </template>
    </basic-heading>

    <b-row class="my-5"
      ><b-col
        ><div class="display-4 font-scale-1x-5 text-center">
          Currently testing / reviewing / blocked
        </div></b-col
      ></b-row
    >
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading.vue";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ScheduleModel from "../../../models/lab/ScheduleModel";

export default {
  components: { BasicHeading, HeaderButtonGroup },
  name: "ScheduleEdit",
  props: {
    model: {
      type: ScheduleModel,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      id: this.$route.params.schedule_id || null,
      schedule: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [],
      };
    },
  },
  methods: {
    init() {
      this.loading = true;
      let init = [];
      init.push(this.fetch());
      return Promise.all(init).then(() => {
        this.loading = false;
      });
    },
    fetch() {
      if (this.model) {
        return new Promise(() => {
          return (this.schedule = this.model);
        });
      } else if (this.id) {
        let schedule = new ScheduleModel({ id: this.id });
        return schedule.fetch().then(() => {
          return (this.schedule = schedule);
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
